import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.scss";
import FontAwesome from "react-fontawesome";

const mql = window.matchMedia(`(min-width: 800px)`);
class DrawerToggle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mql: mql,
      hidden: false
    };
    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
  }

  componentWillMount() {
    mql.addListener(this.mediaQueryChanged);
    this.setState({ mql: mql });
  }
  mediaQueryChanged() {
    this.setState({ hidden: this.state.mql.matches });
  }
  componentWillUnmount() {}
  componentWillReceiveProps(props) {
    this.state = {
      challenge: props.challenge
    };
    this.setState({ hidden: this.state.mql.matches });
  }
  open() {
    this.props.dispatch({ type: "OPEN_DRAWER" });
  }

  render() {
    if (!this.state.hidden) {
      return (
        <h1 style={{ flexGrow: "0" }}>
          <FontAwesome
            onClick={this.open.bind(this)}
            style={{ paddingRight: "16px" }}
            name="bars"
          />
        </h1>
      );
    }
    return null;
  }
}

export default connect()(DrawerToggle);



// WEBPACK FOOTER //
// ./src/containers/drawer-toggle/index.js